import React from 'react';
import Navbar from '../../components/navbar';
import CRUDSucursales from '../../components/crudSucursales';

function VistaDatosSucursales() {
    return (
        <CRUDSucursales />
    )
}

export default VistaDatosSucursales;